import * as yup from 'yup';

export interface IAccounts {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  contactNumber: string;
  isActive: boolean;
  roleId: string; // Role string[]
  roleName: string;
  dateCreated: string;
  dateUpdated: string;
  businessUnitId: string;
}
export interface AccountsExport {
  firstName: string;
  lastName: string;
  isActive: string | boolean;
  roleName: string;
  dateCreated: string;
  dateUpdated: string;
}

export const accountsSchema = yup.object({
  firstName: yup.string().required('First Name is required').trim(),
  lastName: yup.string().required('Last Name is required').trim(),
  contactNumber:
  yup.string()
  .typeError("Please enter number value only")
  .required()
  .max(11, 'Must be exactly 11 digits') 
  .matches(/^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ0-9\s\-\/.]+$/, 'Please enter valid number'),
  email: yup
    .string()
    .required('Email is required')
    .trim()
    .email('Must be a valid email'),
  username: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      "letters-numbers-only",
      "Username can only contain letters and numbers (no spaces or special characters)",
      (value) => {
        if (!value) return true;
        return /^[A-Za-z0-9]+$/.test(value);
      }
    )
    .test(
      "starts-with-letter",
      "Username must start with a letter",
      (value) => {
        if (!value) return true;
        return /^[A-Za-z]/.test(value);
      }
    )
    .test(
      "valid-length",
      "Username must be 3 to 20 characters long",
      (value) => {
        if (!value) return true;
        return value.length >= 3 && value.length <= 20;
      }
    ),
  roleName: yup.string().trim(),
  roleId: yup.string().required('Role is required').trim(),
  businessUnitId: yup.string().required('Business Unit is required').trim(),
  isActive: yup.boolean().optional().nullable(),
});

export type accountsFields = Omit<
  IAccounts,
  'id' | 'dateCreated' | 'dateUpdated'
>;

export const userAccountsInitialValues: accountsFields = {
  firstName: '',
  lastName: '',
  contactNumber: '',
  email: '',
  username: '',
  isActive: true,
  roleName: '',
  roleId: '',
  businessUnitId: '',
};

export const roleOptions = [
  {
    id: 'superAdmin',
    label: 'SuperAdmin',
    value: 'SuperAdmin',
  },
  {
    id: 'manager',
    label: 'Manager',
    value: 'Manager',
  },
  {
    id: 'admin',
    label: 'Admin',
    value: 'admin',
  },
];
